import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PrimaryCompanyModel } from '../../../awsAppSync/API';
import {
  Roles,
  UpdateSelectedLevel3Value,
  UpdateSelectedPrimaryCompany,
  UserProfileDataState,
  UpdateSelectedLevel3Id,
  UpdateSelectedCoreViewCompanyId,
} from '../../core/store/user-profile.state';
import {
  AuthenticateUserState,
  UpdateSyrcPrimaryCompany,
} from '../../core/store/authenticate-user.state';
import { Router } from '@angular/router';
import { MOBILTEX_MEMBER_OVERVIEW } from '../../shared/constants';
import { HeirarchyFilterServiceService } from '../../shared/service/heirarchy-filter-service/heirarchy-filter-service.service';
import { Level3LevelNameState } from '../../core/store/filter-level3Name.state';
import { PermissionService } from '../../core/services/permission.service';
import { ProfileStoreService } from '../../core/services/profile-store.service';
import { LevelNameService } from '../../core/services/level-name.service';
import { RemoveScreenPageSize } from '../../core/store/screen-pageSize.state';
import { RemoveGenericFilterData } from '../../core/store/generic-filtet.state';
import { RemoveSurveyFilter } from '../../core/store/survey-filter.state';
import { version } from '../../../../package.json';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.css',
})
export class ProfileMenuComponent implements OnInit {
  @Output() closePopup = new EventEmitter<void>();

  primaryCompany$: Observable<
    (PrimaryCompanyModel | null)[] | null | undefined
  >;
  userId$: Observable<string | null>;
  userName$: Observable<string | null>;
  userEmail$: Observable<string | null>;
  isMTXUser$: Observable<boolean | null>;
  roles$: Observable<(Roles | null)[] | null | undefined>;
  syrcPrimaryCompanies$: Observable<
    (PrimaryCompanyModel | null)[] | null | undefined
  >;
  selectedPrimaryCompany$: Observable<string | null>;
  selectedLevel3Value$: Observable<string | null>;

  primaryCompany: (PrimaryCompanyModel | null)[] | null | undefined;
  userId: string | null = null;
  userName: string | null = null;
  userEmail: string | null = null;
  isMTXUser: boolean | null = null;
  roles: (Roles | null)[] | null | undefined = null;

  level3Values: string[] = [];
  primaryCompanyValues: string[] = [];
  selectedLevel3Value: string | null = null;
  selectedPrimaryCompanyValue: string | null = null;
  syrcPrimaryCompanies: (PrimaryCompanyModel | null)[] | null | undefined;
  selectedSyrcPrimaryCompany: PrimaryCompanyModel | null | undefined = null;
  primaryCompanyName = '';
  userInitials = '';
  level3Name = '';
  storeLevel3Name$: Observable<string | null>;
  isLoading = false;
  authenticateUserStatePrimaryCompanyId$: Observable<string | null>;
  authenticateUserStatePrimaryCompanyId = '';
  environmentName = '';
  versionNumber = '';
  constructor(
    private store: Store,
    private router: Router,
    private _heirarchyFilterService: HeirarchyFilterServiceService,
    private permissionService: PermissionService,
    private profileService: ProfileStoreService,
    private levelNameService: LevelNameService
  ) {
    this.primaryCompany$ = this.store.select(
      UserProfileDataState.getPrimaryCompany,
    );
    this.userId$ = this.store.select(UserProfileDataState.getUserId);
    this.userName$ = this.store.select(UserProfileDataState.getUserName);
    this.userEmail$ = this.store.select(UserProfileDataState.getUserEmail);
    this.isMTXUser$ = this.store.select(UserProfileDataState.getIsMTXUser);
    this.roles$ = this.store.select(UserProfileDataState.getRoles);
    this.syrcPrimaryCompanies$ = this.store.select(
      UserProfileDataState.getSyrcPrimaryCompanies,
    );
    this.selectedPrimaryCompany$ = this.store.select(
      UserProfileDataState.getSelectedPrimaryCompany,
    );
    this.selectedLevel3Value$ = this.store.select(
      UserProfileDataState.getSelectedLevel3Value,
    );
    this.storeLevel3Name$ = this.store.select(
      Level3LevelNameState.getLevel3LevelNameId,
    );
    this.authenticateUserStatePrimaryCompanyId$ = this.store.select(
      AuthenticateUserState.getSyrcPrimaryCompanyId,
    );
  }

  ngOnInit(): void {
    this.environmentName = environment.name;
    this.versionNumber = version;
    this.storeLevel3Name$.subscribe((level3Name) => {
      this.level3Name = level3Name!;
    });

    this.isMTXUser$.subscribe((isMTXUser) => {
      this.isMTXUser = isMTXUser ?? false;
    });

    this.selectedPrimaryCompany$.subscribe((selectedPrimaryCompany) => {
      this.selectedPrimaryCompanyValue = selectedPrimaryCompany ?? '';
    });
    this.authenticateUserStatePrimaryCompanyId$.subscribe(
      (syrcPrimaryCompanyId) => {
        this.authenticateUserStatePrimaryCompanyId = syrcPrimaryCompanyId ?? '';
      },
    );

    this.primaryCompany$.subscribe((primaryCompany) => {
      this.primaryCompany = primaryCompany ?? null;
      this.primaryCompanyName = this.primaryCompany?.[0]?.name ?? '';
      this.primaryCompanyValues =
        this.primaryCompany
          ?.map((company) => company?.name ?? '')
          .filter((name): name is string => !!name) ?? [];
      this.selectedPrimaryCompanyValue =
        this.selectedPrimaryCompanyValue ?? this.primaryCompanyName;
    });

    this.userId$.subscribe((userId) => {
      this.userId = userId ?? '';
    });

    this.userName$.subscribe((userName) => {
      this.userName = userName ?? '';
      this.setUserInitials();
    });

    this.userEmail$.subscribe((userEmail) => {
      this.userEmail = userEmail ?? '';
    });

    if (this.isMTXUser) {
      this.syrcPrimaryCompanies$.subscribe((syrcPrimaryCompanies) => {
        this.syrcPrimaryCompanies = syrcPrimaryCompanies;
      });
      this.selectedPrimaryCompany$.subscribe((selectedPrimaryCompany) => {
        this.selectedSyrcPrimaryCompany =
          this.syrcPrimaryCompanies?.find(
            (company) => company?.name === selectedPrimaryCompany,
          ) ?? null;
        this.primaryCompanyName = this.selectedSyrcPrimaryCompany?.name ?? '';
      });
    } else {
      this.roles$.subscribe((roles) => {
        this.roles = roles ?? [];
        const pcId =
          this.authenticateUserStatePrimaryCompanyId ??
          this.primaryCompany?.[0]?.id;
        const pcRoles = this.roles?.filter(
          (role) => role?.syrcPrimaryCompanyId === pcId,
        );
        this.level3Values = pcRoles!
          .filter((role) => role?.level3Value)
          .map((role) => role!.level3Value!);
      });

      this.selectedLevel3Value$.subscribe((selectedLevel3Value) => {
        this.selectedLevel3Value = selectedLevel3Value ?? '';
      });
      if (this.level3Values && !this.selectedLevel3Value) {
        this.selectedLevel3Value = this.level3Values[0];
      }
    }
    this.permissionService.transformData(); //checking for no-access isssue
  }

  async onLevel3ValueChange(event: Event): Promise<void> {
    this.isLoading = true;
    const selectElement = event.target as HTMLSelectElement;
    this.selectedLevel3Value = selectElement.value;
    this.onChangeOfLevel3(selectElement.value);
  }

  async onChangeOfLevel3(value: string) {
    this.transferLevel3ValueToStore(value);
    await this.levelNameService.generateLevelNames();
    window.location.reload();
    this.isLoading = false;
  }

  transferLevel3ValueToStore(value: string) {
    this.store.dispatch(new UpdateSelectedLevel3Value(value));
    const selectedCompanyId = this.selectedSyrcPrimaryCompany?.id;

    const matchingRole = this.roles?.find(
      (role) =>
        role?.level3Value === value &&
        (!selectedCompanyId ||
          role?.syrcPrimaryCompanyId === selectedCompanyId),
    );
    const selectedLevel3Id = matchingRole?.level3Id ?? '';
    this.store.dispatch(new UpdateSelectedLevel3Id(selectedLevel3Id));
  }

  onPrimaryCompanyValueChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedSyrcPrimaryCompany = this.getPrimaryCompanyByName(
      selectElement.value,
    );

    this.level3Values = this.roles!.filter(
      (role) =>
        role?.syrcPrimaryCompanyId === this.selectedSyrcPrimaryCompany?.id,
    ).map((role) => role!.level3Value!);
    this.selectedLevel3Value = this.level3Values[0];
    this.transferLevel3ValueToStore(this.selectedLevel3Value);
    this.onSyrcPrimaryCompanyValueChange();
  }

  getPrimaryCompanyByName(
    name: string,
  ): PrimaryCompanyModel | null | undefined {
    return this.primaryCompany
      ?.filter((c: any): c is PrimaryCompanyModel => c !== null)
      .find((company: any) => company.name === name);
  }

  onSyrcPrimaryCompanyValueChange(): void {
    if (this.selectedSyrcPrimaryCompany) {
      this.primaryCompanyName = this.selectedSyrcPrimaryCompany.name ?? '';
      this.store.dispatch(
        new UpdateSelectedPrimaryCompany(
          this.selectedSyrcPrimaryCompany.name ?? '',
        ),
      );
      this.store.dispatch(
        new UpdateSyrcPrimaryCompany(
          this.selectedSyrcPrimaryCompany.id ?? '',
          this.selectedSyrcPrimaryCompany.name ?? '',
        ),
      );

      this.store.dispatch(
        new UpdateSelectedCoreViewCompanyId(
          this.selectedSyrcPrimaryCompany.corViewCompanyId ?? '',
        ),
      );
      this.store.dispatch(new RemoveGenericFilterData());
      this.store.dispatch(new RemoveSurveyFilter());
      this.generateLevelNames();
    }
  }

  async generateLevelNames() {
    this.isLoading = true;
    await this.levelNameService.generateLevelNames();
    this._heirarchyFilterService.setIsPrimaryCompanyChange(true);
    this.removeselectedFilter();
    window.location.reload();
    this.isLoading = false;
    this.closePopup.emit();
  }

  removeselectedFilter() {
    this.levelNameService.clearAllFilterAndStores();
  }

  setUserInitials() {
    if (this.userName) {
      const nameParts = this.userName.split(' ');
      const initials = nameParts.map((part) => part.charAt(0)).join('');
      this.userInitials = initials.toUpperCase();
    }
  }

  async logout(): Promise<void> {
    if (this.profileService.isAuth0Enabled) {
      await this.profileService.logoutUser();
      this.router.navigate(['/login']);
      return;
    }
    this.profileService.logoutUser();
    this.store.dispatch(new RemoveScreenPageSize());
  }

  ManageMobiltexMemberClicked() {
    this.closePopup.emit();
    this.router.navigate([MOBILTEX_MEMBER_OVERVIEW]);
  }
}
